import React, { useState } from "react";
import { Formik, Form } from "formik";
// eslint-disable-next-line no-unused-vars
import { useSelector } from "react-redux";
import UploadMedia from "../../../components/media/UploadMedia";

const Step2MediaForm = ({
  media = { images: [], promotion_videos: [], attachments: [] },
  setMedia,
  onPrevious,
  onNext,
}) => {
  const [images, setImages] = useState(media.images || []);
  const [promotionVideos, setPromotionVideos] = useState(media.promotion_videos || []);
  const [attachments, setAttachments] = useState(media.attachments || []);

  return (
    <Formik
      initialValues={{}}
      onSubmit={() => {
        const finalMedia = {
          images,
          promotion_videos: promotionVideos,
          attachments,
        };
        setMedia(finalMedia);
        if (onNext) onNext(finalMedia);
      }}
    >
      {({ handleSubmit, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <div className="container my-4">
            <h5 className="mb-3 fw-bold">Step 2: Upload Media</h5>
            <UploadMedia
              images={images}
              setImages={setImages}
              videos={promotionVideos}
              setVideos={setPromotionVideos}
              attachments={attachments}
              setAttachments={setAttachments}
              label="Upload Promotion Media"
            />
            <div className="d-flex justify-content-between mt-4">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onPrevious}
              >
                Previous
              </button>
              <button type="submit" className="btn btn-success" disabled={isSubmitting}>
                Continue
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Step2MediaForm;